export default "__VITE_ASSET__fTcPh1nI__"